import React from "react"
import { useNavigate } from "react-router-dom"
import { Button, Result } from "antd"
import { useTranslation } from "react-i18next"
import { LockOutlined } from "@ant-design/icons"
import { routes } from "router/routes"
import styles from "./index.module.css"

const Forbidden403 = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleGoHome = () => {
    navigate(routes.proHomeRootPath())
  }

  return (
    <div className={styles.container}>
      <Result
        icon={<LockOutlined className={styles.icon} />}
        status="403"
        title={<span className={styles.title}>403</span>}
        subTitle={
          <div className={styles.subtitle}>
            {t("errors.403.message", {
              defaultValue:
                "Sorry, you don't have permission to access this page. Please contact your administrator if you believe this is an error."
            })}
          </div>
        }
        extra={
          <div className={styles.buttonContainer}>
            <Button size="large" onClick={handleGoBack}>
              {t("errors.403.go_back", { defaultValue: "Go Back" })}
            </Button>
            <Button type="primary" size="large" onClick={handleGoHome}>
              {t("errors.403.go_home", { defaultValue: "Go to Home" })}
            </Button>
          </div>
        }
      />
    </div>
  )
}

export default Forbidden403
